// authentication routes
import { lazy } from 'react'
const SignUp = lazy(async () => await import('../screens/authScreen/SignUp'))
const Login = lazy(async () => await import('../screens/authScreen/Login'))
const ResetPassword = lazy(async () => await import('../screens/authScreen/ResetPassword'))
export default { SignUp, Login, ResetPassword }
